export default __webpack_public_path__ + "static/media/pj-cobrinha.4e50f785.png";